var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"px-0 fluid"},[_c('b-row',{staticClass:"mx-0"},[_c('b-col',[_c('b-form-input',{attrs:{"placeholder":_vm.lang('t_tenantName')}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }